import React from 'react';

export interface EducationItem {
  degree: string;
  school: string;
  location: string;
  dates: string;
  gpa?: string;
}

interface EducationFormatterProps {
  education: EducationItem[];
  className?: string;
}

/**
 * Consistent education formatter component that follows the standard format:
 * - First line: Degree name (bolded)
 * - Second line: Institution – Location – Dates (not bolded)
 */
export function EducationFormatter({ education, className = "" }: EducationFormatterProps) {
  return (
    <div className={className}>
      {education.map((edu, index) => (
        <div key={index} className="mb-4">
          <div className="font-bold text-current">{edu.degree}</div>
          <div className="text-current">
            {edu.school} – {edu.location} – {edu.dates}
          </div>
        </div>
      ))}
    </div>
  );
}

/**
 * Alternative function that returns formatted education items as an array
 * for templates that need more control over styling
 */
export function formatEducationItem(edu: EducationItem) {
  return {
    degreeText: edu.degree,
    institutionText: `${edu.school} – ${edu.location} – ${edu.dates}`
  };
}